// extracted by mini-css-extract-plugin
export default {"success":"Error_success__was6O","extra":"Error_extra__fNiRC"};